import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import api from '../../utils/api';
import { Typography, Box, Card, CardContent, Grid } from '@mui/material';

const Dashboard = () => {
  const [data, setData] = useState({});
  const { adminUser } = useContext(AuthContext);

  useEffect(() => {
    const fetchData = async () => {
      if (!adminUser) return;
      const config = { headers: { Authorization: `Bearer ${adminUser.accessToken}` } };
      try {
        const [usersRes, appointmentsRes, reportsRes] = await Promise.all([
          api.get('/admin/users', config),
          api.get('/admin/appointments', config),
          api.get('/admin/reports', config),
        ]);
        setData({
          users: { patients: usersRes.data.patients.length, doctors: usersRes.data.doctors.length },
          appointments: appointmentsRes.data,
          revenue: reportsRes.data.totalRevenue,
        });
      } catch (err) {
        console.error('Dashboard fetch error:', err.response?.data);
      }
    };
    fetchData();
  }, [adminUser]);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Dashboard</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total Patients: {data.users?.patients || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total Doctors: {data.users?.doctors || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total Appointments: {data.appointments?.length || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card>
            <CardContent>
              <Typography variant="h6">Total Revenue: ₹{data.revenue || 0}</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;